import { configureStore } from "@reduxjs/toolkit";
import dialogSlice from "../components/dialog/dialogSlice";
import loginReducer from "../features/login/loginSlice";
import userSlice from "../features/user/userSlice";
import menuSlice from "../features/menu/menuSlice";
import rightsSlice from "../features/rights/rightsSlice";
import userTypeSlice from "../features/userType/userTypeSlice";
import muiDrawerSlice from "../components/muidrawer/muiDrawerSlice";
import dashboardSlice from "../features/dashboard/dashboardSlice";
import bannerSlice from "../features/banner/bannerSlice";
import cmsSlice from "../features/cms/cmsSlice";
import seotagSlice from "../features/seotag/seotagSlice";
import testimonialSlice from "../features/testimonial/testimonialSlice";
import serviceSlice from "../features/service/serviceSlice";
import faqSlice from "../features/faq/faqSlice";
import usefullinksSlice from "../features/usefullinks/usefullinksSlice";
import contactSlice from "../features/contact/contactSlice";
import paginationSlice from "../features/pagination/paginationSlice";
import settingSlice from "../features/setting/settingSlice";
import ticketBookingSlice from "../features/ticketbooking/ticketBookingSlice";
import workflowSlice from "../features/workflow/workflowSlice";
import industrySlice from "../features/industry/industrySlice";
import clientLogoSlice from "../features/clientlogo/clientLogoSlice";
import aboutSlice from "../features/about/aboutSlice";
import newsSlice from "../features/news/newsSlice";
import projectsSlice from "../features/projects/projectsSlice";
import sizeSlice from "../features/size/sizeSlice";
import categorySlice from "../features/category/categorySlice";
import subCategorySlice from "../features/subcategory/subCategorySlice";
import countrySlice from "../features/country/countrySlice";
import certificateSlice from "../features/certificate/certificateSlice";
import productSlice from "../features/product/productSlice";
import blogSlice from "../features/blog/blogSlice";

const store = configureStore({
  reducer: {
    login: loginReducer,
    dashboard: dashboardSlice,
    dialog: dialogSlice,
    muidrawer: muiDrawerSlice,
    user: userSlice,
    menu: menuSlice,
    rights: rightsSlice,
    userType: userTypeSlice,
    cms: cmsSlice,
    pagination: paginationSlice,
    seotag: seotagSlice,
    service: serviceSlice,
    testimonial: testimonialSlice,
    banner: bannerSlice,
    faq: faqSlice,
    usefullinks: usefullinksSlice,
    contact: contactSlice,
    setting: settingSlice,
    ticketBooking: ticketBookingSlice,
    workflow: workflowSlice,
    industry: industrySlice,
    clientLogo: clientLogoSlice,
    about: aboutSlice,
    news: newsSlice,
    projects: projectsSlice,
    size: sizeSlice,
    category: categorySlice,
    subCategory: subCategorySlice,
    country: countrySlice,
    certificate: certificateSlice,
    product: productSlice,
    blog: blogSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
